import PropTypes from "prop-types";
import React from "react";
import styles from "./styles";
import { ExportToCsv } from "export-to-csv";
import { version } from "../../config";

import {
	AppBar,
	Drawer,
	Fab,
	Toolbar,
	Typography,
	withStyles
} from "@material-ui/core";

import { ReactComponent as ShareIcon } from "../../assets/images/icons/share.svg";
import { ReactComponent as ExportIcon } from "../../assets/images/icons/export.svg";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Results from "./Results";

import { Share } from "../index";
import OfficeResults from "./OfficeResults";
import Carousel from "../carousel";

class Sidebar extends React.Component {
	constructor(props) {
		super(props);
		this.anchorEl = React.createRef();
	}

	state = {
		anchorEl: null,
		element: "button",
		open: false
	};

	setButtonRef = element => {
		this.anchorEl = element;
		this.setState(prevState => ({
			...prevState,
			element
		}));
	};

	handleShareOpen = event => {
		this.setState({ anchorEl: event.currentTarget });
	};

	handleShareClose = () => {
		this.setState(prevState => ({
			...prevState,
			anchorEl: null
		}));
	};

	exportCSV = () => {
		const { data } = this.props;
		const keys = Object.keys(data);
		if (keys.length === 0) {
			return true;
		}

		const headers = Object.keys(data[keys[0]][0]).reduce((all, key) => {
			let label = key;
			if (key === "floor") {
				label = "etage";
			}
			if (key.match(/terrace/gimu)) {
				label = key.replace(/terrace/gimu, "terrasse");
			}
			if (key === "price") {
				label = "prix";
			}
			if (key.match(/balcony/gimu)) {
				label = key.replace(/balcony/gimu, "balcon");
			}
			if (key === "garden") {
				label = "jardin";
			}
			if (key === "building") {
				label = "batiment";
			}
			all.push(label);

			return all;
		}, []);

		const csvArr = keys.reduce((items, key) => {
			const item = data[key];
			return items.concat(item);
		}, []);

		const options = {
			fieldSeparator: ",",
			quoteStrings: '"',
			decimalSeparator: ".",
			showLabels: true,
			showTitle: false,
			title: `Data-${new Date().getTime()}`,
			filename: `Data-${new Date().getTime()}`,
			useTextFile: false,
			useBom: true,
			useKeysAsHeaders: false,
			headers
		};

		const csvExporter = new ExportToCsv(options);

		return csvExporter.generateCsv(csvArr);
	};

	render() {
		const { classes, sidebar, data, count } = this.props;
		const { opened } = sidebar;
		const { anchorEl } = this.state;
		const open = Boolean(anchorEl);

		return (
			<>
				<Drawer
					anchor="right"
					classes={{
						paper: classes.drawerPaper
					}}
					open={opened}
					variant="persistent"
				>
					<div className={classes.toolbar} />
					<div className={classes.wrapper}>
						<AppBar
							classes={{
								root: classes.resultHeaderAppBar
							}}
							color="inherit"
							position="static"
						>
							<Toolbar
								classes={{
									root: classes.resultHeaderToolbar
								}}
							>
								<Typography
									classes={{
										root: classes.resultHeaderTitle
									}}
									variant="h3"
								>
									<span className={classes.resultHeaderCount}>{count}</span>
									{version.office ? "Espaces" : "résultats"}
								</Typography>
								<div className={classes.resultHeaderActions}>
									{!version.office && (
										<Fab
											className={classes.resultHeaderButton}
											onClick={this.exportCSV}
											variant="extended"
										>
											<ExportIcon className={classes.resultHeaderIcon} />
											<span>{"export.csv"}</span>
										</Fab>
									)}
									<Fab
										aria-haspopup="true"
										aria-owns={this.state.open ? "simple-popper" : null}
										buttonRef={this.setButtonRef}
										className={classes.resultHeaderButton}
										onClick={this.handleShareOpen}
										variant="extended"
									>
										<ShareIcon className={classes.resultHeaderIcon} />
										<span>{"partage"}</span>
									</Fab>
									<Share
										element={this.anchorEl}
										onClose={this.handleShareClose}
										open={open}
										url={window.location.href}
									/>
								</div>
							</Toolbar>
						</AppBar>
						{version.office ? (
							<OfficeResults classes={classes} data={data} />
						) : (
							<Results classes={classes} data={data} />
						)}
					</div>
				</Drawer>
				{!version.office && opened ? <Carousel /> : null}
			</>
		);
	}
}

const mapStateToProps = state => ({
	...state.filtered[state.helpers.building],
	...state.helpers
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

Sidebar.propTypes = {
	classes: PropTypes.object.isRequired,
	count: PropTypes.number.isRequired,
	data: PropTypes.object.isRequired,
	sidebar: PropTypes.object.isRequired
};

export default withStyles(styles)(
	connect(mapStateToProps, mapDispatchToProps)(Sidebar)
);
